var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _g, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1473_19824)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 306.785,
    width: 642.781,
    height: 53.2158,
    fill: "#FFC900"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    width: 642.957,
    height: 309,
    fill: "#FFC900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M594.233 121.273L591.551 187.126H570.368L565.275 121.273H594.233Z",
    stroke: "#E2442F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M527.999 284.042L497.958 111.168H323.75L352.234 295.745H632.425V283.975L527.999 284.042Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M559.5 109.5L564.675 192.913H595.303L601.381 109.5H559.5ZM591.474 186.965H570.292L565.199 121.113H594.156L591.474 186.965Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M595 121.5H565.5L571 187H592L595 121.5Z",
    fill: "#F1F333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M587.455 187.124H583.441L573.312 79.0469H577.327L587.455 187.124Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M559.576 109.664L564.751 193.077H595.38L601.457 109.664H559.576ZM591.551 187.129H570.368L565.275 121.277H594.233L591.551 187.129Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M371 272.816L346.5 121.816H490L514.5 272.816H371Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M347.985 122.727H488.846L513.428 271.46H371.492L347.985 122.727Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M477.5 145.066H360.25L370 215.316H385L390.5 250.816H495.5L477.5 145.066Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M569.817 239.898C562.258 247.249 560.976 264.477 560.976 264.477Z",
    fill: "#98282A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M578.781 242.422C573.854 252.903 568.747 266.653 574.694 268.597C578.031 269.688 583.644 270.671 584.683 268.335",
    fill: "#98282A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M589.645 244.312C584.086 258.257 580.632 268.214 587.243 270.496C593.361 272.607 610.764 275.448 610.972 270.303C611.139 266.081 597.448 265.504 598.649 261.459C599.85 257.413 600.744 254.532 600.744 254.532",
    fill: "#98282A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M600.514 264.196C600.514 264.196 617.356 268.047 620.748 257.485H641.957V229.809C622.865 229.809 583.666 229.809 574.667 229.809C564.927 229.809 559.626 232.505 553.453 243.419C547.281 254.333 547.488 273.495 550.717 278.149C554.135 283.074 558.113 280.188 558.795 274.483C559.834 265.797 557.82 260.223 561.87 265.508C564.579 269.044 571.691 268.385 573.588 267.813",
    fill: "#98282A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M569.817 239.898C562.258 247.249 560.976 264.477 560.976 264.477",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M578.781 242.422C573.854 252.903 568.747 266.653 574.694 268.597C578.031 269.688 583.644 270.671 584.683 268.335",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M589.645 244.312C584.086 258.257 580.632 268.214 587.243 270.496C593.361 272.607 610.764 275.448 610.972 270.303C611.139 266.081 597.448 265.504 598.649 261.459C599.85 257.413 600.744 254.532 600.744 254.532",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M600.514 264.196C600.514 264.196 617.356 268.047 620.748 257.485H641.957V229.809C622.865 229.809 583.666 229.809 574.667 229.809C564.927 229.809 559.626 232.505 553.453 243.419C547.281 254.333 547.488 273.495 550.717 278.149C554.135 283.074 558.113 280.188 558.795 274.483C559.834 265.797 557.82 260.223 561.87 265.508C564.579 269.044 571.691 268.385 573.588 267.813",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M309.777 75.4476C311.827 74.5869 311.728 69.701 309.554 64.5346C307.38 59.3682 303.956 55.8778 301.905 56.7385C299.854 57.5991 299.954 62.4851 302.127 67.6514C304.301 72.8178 307.726 76.3083 309.777 75.4476Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M321.018 66.615C322.978 61.364 322.877 56.4781 320.793 55.7021C318.709 54.926 315.43 58.5537 313.47 63.8047C311.51 69.0557 311.611 73.9416 313.695 74.7176C315.78 75.4937 319.058 71.866 321.018 66.615Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M328.661 78.0499C333.706 74.9271 336.577 70.4322 335.074 68.0103C333.572 65.5883 328.263 66.1565 323.218 69.2793C318.173 72.4021 315.302 76.897 316.805 79.3189C318.308 81.7409 323.616 81.1727 328.661 78.0499Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M336.729 90.8738C337.719 88.0585 334.27 84.2848 329.025 82.445C323.781 80.6051 318.726 81.3958 317.736 84.2111C316.746 87.0264 320.195 90.8001 325.44 92.6399C330.685 94.4798 335.739 93.6891 336.729 90.8738Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M321.112 101.439C322.81 100.682 322.601 96.5187 320.644 92.1407C318.686 87.7628 315.723 84.8279 314.024 85.5854C312.325 86.3429 312.535 90.5061 314.492 94.884C316.449 99.2619 319.413 102.197 321.112 101.439Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M308.78 98.952C311.65 93.6893 312.393 88.5616 310.439 87.4989C308.486 86.4363 304.575 89.8411 301.706 95.1038C298.836 100.367 298.093 105.494 300.046 106.557C302 107.62 305.91 104.215 308.78 98.952Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M299.21 93.119C304.422 90.3027 307.649 86.1781 306.418 83.9065C305.187 81.6349 299.965 82.0765 294.753 84.8928C289.542 87.7091 286.315 91.8337 287.546 94.1053C288.777 96.3769 293.999 95.9354 299.21 93.119Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M306.373 78.452C307.196 75.7496 303.357 72.1909 297.8 70.5034C292.243 68.816 287.071 69.6387 286.248 72.3412C285.426 75.0436 289.264 78.6023 294.821 80.2898C300.378 81.9773 305.55 81.1544 306.373 78.452Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M312.895 89.8931C317.484 89.8931 321.204 86.1254 321.204 81.4778C321.204 76.8302 317.484 73.0625 312.895 73.0625C308.306 73.0625 304.587 76.8302 304.587 81.4778C304.587 86.1254 308.306 89.8931 312.895 89.8931Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M275.497 112.221C277.675 112.221 279.439 108.238 279.439 103.324C279.439 98.4095 277.675 94.4258 275.497 94.4258C273.32 94.4258 271.555 98.4095 271.555 103.324C271.555 108.238 273.32 112.221 275.497 112.221Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M271.468 113.424C273.079 112.237 271.928 107.946 268.896 103.841C265.865 99.7357 262.1 97.3702 260.489 98.5574C258.877 99.7446 260.028 104.035 263.06 108.14C266.092 112.245 269.856 114.611 271.468 113.424Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M270.098 117.496C270.562 114.961 266.579 112.11 261.202 111.128C255.824 110.147 251.089 111.408 250.625 113.944C250.161 116.479 254.145 119.33 259.522 120.312C264.899 121.293 269.635 120.032 270.098 117.496Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M265.766 130.397C269.836 127.157 271.949 123.044 270.485 121.209C269.021 119.374 264.535 120.512 260.464 123.752C256.394 126.991 254.281 131.105 255.745 132.94C257.209 134.775 261.695 133.636 265.766 130.397Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M274.83 134.49C276.762 129.617 276.687 125.019 274.662 124.218C272.638 123.418 269.431 126.719 267.5 131.592C265.568 136.464 265.644 141.063 267.668 141.863C269.692 142.664 272.899 139.363 274.83 134.49Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M280.549 141.476C282.496 141.407 283.924 137.189 283.74 132.056C283.555 126.924 281.827 122.819 279.881 122.889C277.934 122.959 276.506 127.177 276.691 132.309C276.875 137.442 278.603 141.546 280.549 141.476Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M299.568 123.623C300.231 121.175 296.917 118.152 292.166 116.87C287.416 115.589 283.029 116.534 282.367 118.982C281.705 121.43 285.019 124.453 289.769 125.735C294.519 127.016 298.906 126.071 299.568 123.623Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M290.067 116.167C294.387 116.012 297.834 114.387 297.768 112.538C297.701 110.688 294.146 109.314 289.826 109.469C285.507 109.624 282.06 111.249 282.126 113.099C282.193 114.948 285.748 116.322 290.067 116.167Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M285.757 108.283C288.087 105.23 288.934 101.963 287.651 100.986C286.368 100.01 283.439 101.693 281.11 104.746C278.781 107.799 277.933 111.065 279.216 112.042C280.5 113.019 283.428 111.336 285.757 108.283Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M276.446 126.775C280.96 126.775 284.619 123.12 284.619 118.612C284.619 114.104 280.96 110.449 276.446 110.449C271.932 110.449 268.273 114.104 268.273 118.612C268.273 123.12 271.932 126.775 276.446 126.775Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M312.687 90.1172V166.91",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M282.298 124.312C300.5 139.136 308.104 166.294 308.104 166.294",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M331.72 224.619C331.72 224.619 331.72 282.511 331.72 288.924C331.72 295.517 326.152 295.026 326.152 295.026H300.012C300.012 295.026 294.657 295.445 294.454 289.294C306.185 283.336 315.017 272.508 318.286 259.475H304.641C304.641 259.475 307.571 256.927 307.4 252.891C313.676 252.142 312.872 243.258 307.336 243.159C306.93 243.15 306.569 242.902 306.447 242.514C306.081 241.373 304.753 238.91 299.985 235.957C298.612 235.104 296.68 234.599 294.445 234.432C294.445 228.529 294.445 224.614 294.445 224.614C294.445 215.631 303.968 214.391 303.968 208.09V177.843C303.968 173.022 302.676 170.019 298.947 166.289H327.218C323.484 170.019 322.197 173.022 322.197 177.843V208.09C322.197 214.395 331.72 215.635 331.72 224.619Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M318.286 259.477C315.017 272.51 306.185 283.338 294.454 289.295C288.191 292.479 281.101 294.274 273.592 294.274C252.022 294.274 233.91 279.469 228.898 259.477H318.286Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M281.083 236.826C277.462 238.336 274.107 240.555 271.723 243.487C270.495 242.634 269.077 241.809 267.406 241.042C260.673 237.949 254.171 240.97 249.118 243.996C246.147 241.782 246.432 233.768 246.07 230.075C245.628 225.623 253.774 225.885 257.567 226.183C261.36 226.476 269.876 226.679 275.267 231.008C279.471 234.386 281.083 236.826 281.083 236.826Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M286.999 259.477H239.469C237.513 257.979 231.968 255.855 232.027 252.392C232.081 248.924 238.177 248.292 241.04 248.252C242.747 248.229 245.578 246.11 249.118 243.994C254.171 240.968 260.673 237.947 267.406 241.041C269.077 241.807 270.495 242.632 271.723 243.485C272.919 244.315 273.931 245.167 274.811 246.019C278.356 249.415 279.724 252.671 282.181 253.677C285.879 255.188 286.999 257.339 286.999 259.477Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M307.404 253.456C307.318 256.518 305.49 258.628 304.853 259.269C304.722 259.4 304.546 259.472 304.356 259.472H287.658C287.297 259.472 287.003 259.197 286.963 258.836C286.75 256.915 285.509 255.034 282.181 253.672C279.724 252.666 278.356 249.41 274.811 246.014C274.084 245.311 273.267 244.603 272.328 243.913C271.998 243.669 271.958 243.191 272.233 242.885C274.572 240.246 277.715 238.226 281.083 236.824C285.585 234.943 290.494 234.158 294.445 234.438C296.68 234.605 298.613 235.11 299.985 235.962C304.934 239.024 306.176 241.568 306.483 242.646C306.573 242.957 306.853 243.169 307.174 243.164C312.683 243.092 313.676 251.602 307.955 252.802C307.644 252.865 307.413 253.14 307.404 253.456Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M641.871 296.766H-40.8711V316.807H641.871V296.766Z",
    fill: "#23A094"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M640.742 297.892V315.678H-39.7423V297.892H640.742ZM643 295.637H-42V317.933H643V295.637Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M47.637 179.102V178.904L53.9948 170.457H96.4585L91.1347 179.102H47.637Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3738 172.345L52.3784 172.336",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M47.637 179.181V178.906L52.3738 172.344L29.4757 172.348L33.5171 179.181L33.5396 179.217V296.769H48.075L47.637 179.181Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1347 269.194V296.771H48.0749L47.9846 272.021C53.9767 264.819 63.7843 258.059 73.7094 259.331C81.0967 260.278 89.5226 266.718 91.1347 269.194Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1347 179.102V269.194C89.5227 266.718 81.0968 260.278 73.7094 259.331C63.7844 258.059 53.9767 264.819 47.9847 272.022L47.637 179.102H91.1347V179.102Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4718 184.925C54.8077 183.085 50.3915 187.247 52.6086 191.284C54.627 194.959 54.7399 198.048 52.6583 203.311",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M56.948 189.789C56.948 193.262 56.6003 200.852 58.6729 199.855C60.5423 198.953 60.0411 190.741 60.0411 190.741",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0349 187.375C63.0349 187.375 64.4753 190.117 64.2089 196.07C64.0328 200.002 61.2919 201.919 59.8198 197.319",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5282 196.935C65.9203 196.001 67.6317 190.053 68.8463 189.796C70.2958 189.489 69.912 193.088 67.4104 193.498",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8724 195.911C71.1537 196.939 72.7025 189.299 74.1655 189.074C75.7369 188.835 75.5066 191.509 72.7025 192.582",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4484 187.987L82.578 186.945",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8687 187.496L79.4216 198.189",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3077 183.906L85.1021 196.48",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6111 208.756L81.4987 201.617",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1022 201.56C85.6782 201.56 86.1452 201.094 86.1452 200.518C86.1452 199.943 85.6782 199.477 85.1022 199.477C84.5261 199.477 84.0591 199.943 84.0591 200.518C84.0591 201.094 84.5261 201.56 85.1022 201.56Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7001 213.91C72.2886 213.91 72.7657 213.433 72.7657 212.846C72.7657 212.258 72.2886 211.781 71.7001 211.781C71.1115 211.781 70.6344 212.258 70.6344 212.846C70.6344 213.433 71.1115 213.91 71.7001 213.91Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6472 224.476C67.2357 224.476 67.7129 224 67.7129 223.412C67.7129 222.824 67.2357 222.348 66.6472 222.348C66.0587 222.348 65.5815 222.824 65.5815 223.412C65.5815 224 66.0587 224.476 66.6472 224.476Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1587 221.297C73.7472 221.297 74.2243 220.82 74.2243 220.232C74.2243 219.644 73.7472 219.168 73.1587 219.168C72.5701 219.168 72.093 219.644 72.093 220.232C72.093 220.82 72.5701 221.297 73.1587 221.297Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3625 229.941C77.9511 229.941 78.4282 229.465 78.4282 228.877C78.4282 228.289 77.9511 227.812 77.3625 227.812C76.774 227.812 76.2969 228.289 76.2969 228.877C76.2969 229.465 76.774 229.941 77.3625 229.941Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7129 241.355C68.3014 241.355 68.7785 240.879 68.7785 240.291C68.7785 239.703 68.3014 239.227 67.7129 239.227C67.1243 239.227 66.6472 239.703 66.6472 240.291C66.6472 240.879 67.1243 241.355 67.7129 241.355Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M62.624 252.215C63.2126 252.215 63.6897 251.738 63.6897 251.15C63.6897 250.562 63.2126 250.086 62.624 250.086C62.0355 250.086 61.5583 250.562 61.5583 251.15C61.5583 251.738 62.0355 252.215 62.624 252.215Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5962 256.179C72.1847 256.179 72.6618 255.703 72.6618 255.115C72.6618 254.527 72.1847 254.051 71.5962 254.051C71.0076 254.051 70.5305 254.527 70.5305 255.115C70.5305 255.703 71.0076 256.179 71.5962 256.179Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8713 267.894C70.4599 267.894 70.937 267.418 70.937 266.83C70.937 266.242 70.4599 265.766 69.8713 265.766C69.2828 265.766 68.8057 266.242 68.8057 266.83C68.8057 267.418 69.2828 267.894 69.8713 267.894Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6379 269.824C78.2265 269.824 78.7036 269.347 78.7036 268.76C78.7036 268.172 78.2265 267.695 77.6379 267.695C77.0494 267.695 76.5723 268.172 76.5723 268.76C76.5723 269.347 77.0494 269.824 77.6379 269.824Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9353 275.203C74.5238 275.203 75.0009 274.726 75.0009 274.139C75.0009 273.551 74.5238 273.074 73.9353 273.074C73.3467 273.074 72.8696 273.551 72.8696 274.139C72.8696 274.726 73.3467 275.203 73.9353 275.203Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M62.353 271.5C62.9416 271.5 63.4187 271.023 63.4187 270.435C63.4187 269.848 62.9416 269.371 62.353 269.371C61.7645 269.371 61.2874 269.848 61.2874 270.435C61.2874 271.023 61.7645 271.5 62.353 271.5Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3513 280.375C65.9398 280.375 66.417 279.898 66.417 279.31C66.417 278.723 65.9398 278.246 65.3513 278.246C64.7628 278.246 64.2856 278.723 64.2856 279.31C64.2856 279.898 64.7628 280.375 65.3513 280.375Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M79.968 284.332C80.5565 284.332 81.0336 283.855 81.0336 283.267C81.0336 282.68 80.5565 282.203 79.968 282.203C79.3794 282.203 78.9023 282.68 78.9023 283.267C78.9023 283.855 79.3794 284.332 79.968 284.332Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M79.968 252.215C80.5565 252.215 81.0336 251.738 81.0336 251.15C81.0336 250.562 80.5565 250.086 79.968 250.086C79.3794 250.086 78.9023 250.562 78.9023 251.15C78.9023 251.738 79.3794 252.215 79.968 252.215Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5646 225.037C74.45 223.919 74.6712 227.82 72.6438 228.005C70.8647 228.162 69.8035 225.723 71.5646 225.037Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5031 235.346C65.279 233.894 68.2863 230.588 70.0564 232.09C71.6097 233.411 70.4673 236.23 68.5031 235.346Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4031 237.814C78.7306 240.899 74.4996 241.286 74.2242 239.099C73.9849 237.178 76.5948 235.933 77.4031 237.814Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9011 246.707C74.319 250.004 69.799 250.419 69.5055 248.078C69.2481 246.026 72.0342 244.696 72.9011 246.707Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M47.637 179.102H33.5171",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M114.083 80.7941H126.324L131.151 69.5782H144.68V65.127C144.68 64.3423 145.312 63.7109 146.098 63.7109H174.915C175.697 63.7109 176.333 64.3423 176.333 65.127V69.5782H192.165L196.694 80.7039H230.722C235.635 80.7039 239.613 84.677 239.613 89.5837L239.315 140.17C239.288 144.035 236.615 147.377 232.849 148.261L201.105 155.67V216.656C201.105 222.001 194.824 226.564 190.169 226.564C186.556 226.564 128.139 226.564 128.139 226.564C125.182 226.564 120.942 223.394 120.942 218.523V93.8319C120.942 89.3176 118.914 86.9951 116.368 85.1551C115.537 84.5553 114.485 83.9103 113.419 83.306C112.218 82.6251 112.696 80.7941 114.083 80.7941ZM201.105 143.183L219.533 139.101C223.452 138.231 226.248 134.758 226.248 130.745V98.1207C226.248 94.8556 223.597 92.2084 220.328 92.2084H201.105V143.183Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M143.388 225.646L146.856 236.988L181.521 236.573L185.766 225.402L143.388 225.646Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M126.324 80.7969H114.083C112.696 80.7969 112.218 82.6279 113.419 83.3088C114.485 83.9131 115.537 84.5581 116.368 85.1579C118.914 86.9979 120.942 89.3204 120.942 93.8347V218.526C120.942 223.397 125.182 226.567 128.139 226.567H190.169C194.824 226.567 201.105 222.003 201.105 216.659V155.673V80.7969H126.324Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M191.993 213.918V110.928C191.993 110.486 191.632 110.125 191.185 110.125H135.098C134.651 110.125 134.289 110.486 134.289 110.928V211.415C134.289 213.81 136.231 215.749 138.629 215.749H190.159C191.171 215.749 191.993 214.928 191.993 213.918Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M121 101.816H138.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M121 122.727H138.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M121 146.008H138.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M121 170.461H138.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M121 193.898H138.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M161.274 121.488C159.63 121.488 151.502 124.027 150.265 129.809C150.039 130.864 150.161 131.662 150.229 131.983C151.236 136.998 160.484 141.142 168.25 140.583C172.716 140.263 178.193 138.973 178.74 134.923C179.146 131.928 176.139 129.737 173.353 128.929C166.963 127.08 156.831 131.008 153.882 138.405C153.471 139.437 152.938 141.232 153.2 143.397C154.27 152.196 166.259 158.135 174.152 156.949C176.609 156.579 178.717 155.848 179.774 154.631C181.449 152.71 180.731 149.53 179.024 148.101C174.039 143.925 159.301 145.719 155.58 154.545C154.112 158.022 155.002 161.355 155.39 162.523C158.05 170.55 166.58 175.214 173.276 173.897C174.269 173.703 176.83 172.977 177.381 171.155C178.419 167.709 174.911 163.186 168.729 162.063C163.143 161.048 157.318 164.661 155.973 169.468C152.992 180.12 158.285 186.042 166.593 190.362C170.495 192.391 175.602 193.217 176.45 191.913C177.083 190.944 175.629 189.618 174.197 188.775C169.849 186.213 160.213 188.558 159.174 193.821C158.361 197.938 163.514 201.249 164.846 201.97C169.429 204.455 172.043 205.114 173.773 205.005",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M121.1 295.273C121.1 295.273 116.905 292.612 117.334 290.191C117.921 286.889 124.811 250.829 127.087 238.932C127.507 236.736 129.431 235.148 131.666 235.148H189.428C193.388 235.148 196.874 237.755 197.989 241.548L206.862 271.687C207.702 274.294 220.305 279.412 224.017 284.756C227.421 289.658 224.238 295.273 224.238 295.273L223.588 295.823L125.376 296.292L121.1 295.273Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1473_19824",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 235,
    width: 109,
    height: 62
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M121.1 295.273C121.1 295.273 116.905 292.612 117.334 290.191C117.921 286.889 124.811 250.829 127.087 238.932C127.507 236.736 129.431 235.148 131.666 235.148H189.428C193.388 235.148 196.874 237.755 197.989 241.548L206.862 271.687C207.702 274.294 220.305 279.412 224.017 284.756C227.421 289.658 224.238 295.273 224.238 295.273L223.588 295.823L125.376 296.292L121.1 295.273Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1473_19824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.645 285.916C141.266 282.218 136.971 243.84 136.253 237.404V233.621H200.349L217.099 261.871L227.349 282.121V292.568H223.041H150.531C145.009 292.568 141.848 287.855 141.645 285.916Z",
    fill: "#23A094"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M166.864 255.69C169.395 255.69 171.447 253.641 171.447 251.113C171.447 248.585 169.395 246.535 166.864 246.535C164.333 246.535 162.281 248.585 162.281 251.113C162.281 253.641 164.333 255.69 166.864 255.69Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M156.212 269.073C157.379 269.073 158.325 268.128 158.325 266.962C158.325 265.797 157.379 264.852 156.212 264.852C155.045 264.852 154.099 265.797 154.099 266.962C154.099 268.128 155.045 269.073 156.212 269.073Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M156.804 276.924C157.971 276.924 158.917 275.979 158.917 274.814C158.917 273.648 157.971 272.703 156.804 272.703C155.636 272.703 154.69 273.648 154.69 274.814C154.69 275.979 155.636 276.924 156.804 276.924Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M165.478 276.924C166.645 276.924 167.591 275.979 167.591 274.814C167.591 273.648 166.645 272.703 165.478 272.703C164.311 272.703 163.365 273.648 163.365 274.814C163.365 275.979 164.311 276.924 165.478 276.924Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M173.561 276.924C174.728 276.924 175.674 275.979 175.674 274.814C175.674 273.648 174.728 272.703 173.561 272.703C172.393 272.703 171.447 273.648 171.447 274.814C171.447 275.979 172.393 276.924 173.561 276.924Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M181.386 276.924C182.553 276.924 183.499 275.979 183.499 274.814C183.499 273.648 182.553 272.703 181.386 272.703C180.219 272.703 179.273 273.648 179.273 274.814C179.273 275.979 180.219 276.924 181.386 276.924Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 276.924C190.428 276.924 191.374 275.979 191.374 274.814C191.374 273.648 190.428 272.703 189.261 272.703C188.094 272.703 187.148 273.648 187.148 274.814C187.148 275.979 188.094 276.924 189.261 276.924Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M164.954 269.073C166.121 269.073 167.067 268.128 167.067 266.962C167.067 265.797 166.121 264.852 164.954 264.852C163.787 264.852 162.841 265.797 162.841 266.962C162.841 268.128 163.787 269.073 164.954 269.073Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M173.109 269.073C174.276 269.073 175.222 268.128 175.222 266.962C175.222 265.797 174.276 264.852 173.109 264.852C171.942 264.852 170.996 265.797 170.996 266.962C170.996 268.128 171.942 269.073 173.109 269.073Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M180.867 269.073C182.034 269.073 182.98 268.128 182.98 266.962C182.98 265.797 182.034 264.852 180.867 264.852C179.699 264.852 178.753 265.797 178.753 266.962C178.753 268.128 179.699 269.073 180.867 269.073Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M188.751 269.073C189.918 269.073 190.864 268.128 190.864 266.962C190.864 265.797 189.918 264.852 188.751 264.852C187.584 264.852 186.637 265.797 186.637 266.962C186.637 268.128 187.584 269.073 188.751 269.073Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M500.875 238.691L496.375 212.441H475.875L479.75 238.691H500.875Z",
    fill: "#E7E5E4",
    stroke: "black",
    strokeWidth: 2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M478.25 227.441H498.75",
    stroke: "black",
    strokeWidth: 2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M489.125 212.441L493.625 238.816",
    stroke: "black",
    strokeWidth: 2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M458.688 158.316H441.25V165.316H455.375C456.375 166.441 457.775 170.391 455.375 177.191C452.975 183.991 446.958 187.025 444.25 187.691L445.25 195.941C447.875 195.15 453.8 192.791 456.5 189.691C459.875 185.816 463.625 180.067 463.625 170.441C463.625 162.963 459.772 159.337 458.697 158.325L458.688 158.316Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M443.188 215.908H448.983C448.933 222.975 455.995 225.198 457.869 227.124C460.326 229.645 462.227 232.166 462.227 234.971V239.408C462.227 240.116 461.649 240.694 460.94 240.694H423.809C422.685 240.694 421.777 239.787 421.777 238.664V217.468L423.312 215.885L425.719 215.908L424.419 210.744C421.091 210.284 418.413 207.655 417.957 204.245L412.787 165.475C412.638 164.374 412.227 163.31 411.504 162.462C411.035 161.912 410.457 161.429 409.721 161.077C408.745 160.613 407.82 160.36 407.052 160.23C406.122 160.067 405.503 159.102 405.878 158.236C406.104 157.718 406.6 157.316 407.291 157.316H416.742L418.955 151.188H433.888L439.004 157.316H443.37L448.983 194.504L450.198 202.536C450.757 206.243 448.4 209.635 444.964 210.564L443.188 215.908Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M425.312 215.941H445.062",
    stroke: "black",
    strokeWidth: 2
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M424.438 210.191H444.75",
    stroke: "black",
    strokeWidth: 2
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M441.875 204.75H425.75C423.75 204.75 423.281 203.656 423.031 201.781C422.831 200.281 420.333 180.333 419.25 171.125H441.25C442.583 179.042 445.156 195.969 445.719 199.969C446.345 204.425 443.625 204.75 441.875 204.75Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M438.938 157.379H416.625L419 151.316H434L438.938 157.379Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M413.312 168.316L422.875 168.316",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M414.25 176.941L424.625 176.941",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M415.875 188.691L425.764 188.691",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M417.125 197.781L427 197.781",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M482.646 202.045L480.212 199.596C480.777 199.059 481.332 198.567 481.865 198.121C482.212 197.832 482.339 197.359 482.194 196.93L482.185 196.908C482.1 196.655 481.914 196.452 481.684 196.322L473.972 191.915C472.992 191.356 471.845 192.308 472.211 193.372L475.502 202.901C475.706 203.492 476.464 203.664 476.902 203.217C477.426 202.554 478.018 201.855 478.677 201.143L481.192 203.528C481.585 203.903 482.199 203.912 482.605 203.546C483.048 203.149 483.066 202.464 482.646 202.045Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M568.703 174.856C573.54 171.894 576.634 168.146 575.614 166.486C574.595 164.825 569.847 165.881 565.011 168.843C560.174 171.806 557.08 175.553 558.099 177.214C559.119 178.874 563.866 177.819 568.703 174.856Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M565.187 168.386C570.723 164.995 574.421 160.96 573.447 159.374C572.473 157.788 567.196 159.251 561.66 162.642C556.124 166.033 552.426 170.067 553.399 171.653C554.373 173.239 559.651 171.776 565.187 168.386Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M564.169 160.424C569.986 156.861 573.794 152.495 572.674 150.671C571.554 148.847 565.93 150.256 560.114 153.819C554.297 157.381 550.49 161.748 551.61 163.572C552.729 165.396 558.353 163.986 564.169 160.424Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M562.34 152.033C567.188 149.351 570.221 145.561 569.116 143.568C568.01 141.574 563.184 142.131 558.337 144.813C553.489 147.494 550.456 151.284 551.561 153.278C552.667 155.271 557.493 154.714 562.34 152.033Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M603.507 148.002C596.797 146.735 587.148 148.093 583.413 146.207C574.631 141.774 579.047 134.5 585.572 134.5C588.665 134.5 598.12 134.5 601.331 134.5C604.28 134.5 609.481 135.655 611.748 142.397H641.97V175.855H609.743C603.86 182.556 596.283 182.065 596.283 182.065L598.82 148.174L599.123 147.506C599.127 147.506 601.801 147.637 603.507 148.002Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M602.993 162.359H609.789",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M369.75 215.566H387.75L378.5 145.066H360.5L369.75 215.566Z",
    fill: "#D6D3D1",
    stroke: "black",
    strokeWidth: 2
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M366.375 191.316H384.75",
    stroke: "black",
    strokeWidth: 2
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M367.75 201.066H385.625M368.625 208.691H386.75",
    stroke: "black",
    strokeWidth: 2
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M369 145.316L378.75 216.066M361.75 154.566H378.75M363.125 164.691H380.875",
    stroke: "black",
    strokeWidth: 2
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M364.625 174.191H382M365.5 182.941H383.25",
    stroke: "black",
    strokeWidth: 2
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M362.233 130.467C362.551 131.406 362.049 132.423 361.115 132.74C360.181 133.057 359.164 132.556 358.845 131.617C358.526 130.677 359.028 129.661 359.962 129.343C360.896 129.026 361.914 129.527 362.233 130.467Z",
    fill: "#169387",
    stroke: "black",
    strokeWidth: 2
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M371.233 130.467C371.551 131.406 371.049 132.423 370.115 132.74C369.181 133.057 368.164 132.556 367.845 131.617C367.526 130.677 368.028 129.661 368.962 129.343C369.896 129.026 370.914 129.527 371.233 130.467Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1473_19824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid5);
export default __webpack_public_path__ + "static/media/grid5.2a18882a149de14569eac84ce741c402.svg";
export { ForwardRef as ReactComponent };